export default {
  toggleLoading(state, loading) {
    state.loading = loading;
  },
  setDeliveryMethod(state, deliveryMethod) {
    state.deliveryMethod = deliveryMethod;
  },
  setLogisticProviders(state, logisticProviders) {
    state.logisticProviders = logisticProviders;
  },
  setLogisticProvider(state, logisticProvider) {
    state.logisticProvider = logisticProvider;
  },
  setOverlapContract(state, overlapContract) {
    state.overlapContract = overlapContract;
  },
  setContractLogs(state, contractLogs) {
    state.contractLogs = contractLogs;
  },
  setContractData(state, data) {
    state.contractData = data;
  },
  setContracts(state, contracts) {
    state.contracts = {
      currentContracts: contracts.current_contracts,
      historyContracts: contracts.history_contracts,
      draftContracts: contracts.draft_contracts,
      contestedContracts: contracts.contested_contracts,
      detailedContracts: contracts.detailed_contracts,
    };
  },
};



// WEBPACK FOOTER //
// ./src/stores/logistic-providers/mutations.js